<template>
  <div id="order-details">
    <v-container>
      <v-layout row>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-btn flat color="primary" dark @click="$emit('backToOverview')"><v-icon>chevron_left</v-icon>Back to overview</v-btn>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <span><v-chip color="primary" text-color="white"><strong>{{parseDate(dateObject)}}</strong></v-chip></span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout wrap row>
        <v-flex xs12>
          <v-card :color="(items[current].substitution || items[current].comment) ? 'red darken-2' : 'blue darken-2'" dark>
            <v-card-title>
              <v-flex xs4>
                <h2>{{items[current].name}}</h2>
              </v-flex>
              <v-flex xs4>
                <h2>{{ streams[items[current].stream].name }}</h2>
                <h2>{{items[current].size}}</h2>
              </v-flex>
              <v-flex xs4>
                <h2 v-if="items[current].substitution">{{items[current].substitution}}</h2>
                <h2 v-if="items[current].comment">{{items[current].comment}}</h2>
                <h2 v-else><v-icon class="mr-2">cancel</v-icon>No substitutions</h2>
              </v-flex>
            </v-card-title>
          </v-card>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12>
          <v-divider></v-divider>
          <v-card v-if="items && items.length > 0">
            <v-data-table
              :loading="loading"
              :items="[items[current]]"
              hide-actions>

              <template slot="headers" slot-scope="props">
                <tr>
                  <th class="text-xs-center">
                    Company
                  </th>
                  <template class="text-xs-left" v-for="day in daysGroup">
                    <th>Breakfast<br/>{{day}}</th>
                    <th>Lunch<br/>{{day}}</th>
                    <th>Dinner<br/> {{day}}</th>
                    <th>Custom<br/>{{day}}</th>
                  </template>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-center"><strong><h2>{{props.item.company}}</h2></strong></td>
                  <template v-for="day in daysGroup">
                    <td class="text-xs-center">
                      <v-icon v-if="props.item[day].breakfast === 1" color="green">done</v-icon>
                      <v-badge v-else-if="props.item[day].breakfast > 1" color="purple"
                               overlap
                      >
                        <span slot="badge">{{props.item[day].breakfast}}</span>
                        <v-icon color="green">done</v-icon>
                      </v-badge>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                    <td class="text-xs-center">
                      <v-icon v-if="props.item[day].lunch === 1" color="green">done</v-icon>
                      <v-badge v-else-if="props.item[day].lunch > 1" color="purple"
                               overlap
                      >
                        <span slot="badge">{{props.item[day].lunch}}</span>
                        <v-icon color="green">done</v-icon>
                      </v-badge>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                    <td class="text-xs-center">
                      <v-icon v-if="props.item[day].dinner === 1" color="green">done</v-icon>
                      <v-badge v-else-if="props.item[day].dinner > 1" color="purple"
                               overlap
                      >
                        <span slot="badge">{{props.item[day].dinner}}</span>
                        <v-icon color="green">done</v-icon>
                      </v-badge>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                    <td class="text-xs-center">
                      <strong v-if="props.item[day].custom.length > 0"><span v-html="getCodes(props.item[day].custom)"></span></strong>
                      <v-icon v-else color="red">close</v-icon>
                    </td>
                  </template>

                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-spacer></v-spacer>
        <v-flex xs5 text-xs-right>
        <v-divider></v-divider>
          <v-btn center flat color="primary" v-if="current > 0" @click="current--">
            <v-icon>chevron_left</v-icon>Previous
          </v-btn>
        </v-flex>
        <v-flex xs2>
          <v-divider></v-divider>
          <v-btn v-if="orderPacked" round color="teal" @click="isPacked = false; pack(true)" class="white--text">
            <v-icon class="mr-2">check_circle</v-icon><span>Packed!</span>
          </v-btn>
          <v-btn v-else color="blue-grey" round class="white--text" @click="isPacked=true; pack(false)">
            Packed?
          </v-btn>
          <div class="px-4">
            <v-select label="# of bags" :items="[1,2,3,4,5,6,7,8]" :value="items[current].bags" @change="selectBag"></v-select>
          </div>
        </v-flex>
        <v-flex xs5 text-xs-left>
          <v-btn center flat color="primary" v-if="current < items.length - 1" @click="current++">
            Next<v-icon>chevron_right</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-dialog v-model="confirmDialog" max-width="500px">
        <v-card>
          <v-card-title class="headline">
            <v-icon class="mr-2" color="red">warning</v-icon><span>This order has substitutions</span>
          </v-card-title>
          <v-subheader>Substitutions: {{items[current].substitution}}</v-subheader>
          <v-card-text class="text-xs-left">
            Confirm that meals with substitutions was packed?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.stop="isPacked = true; pack(true)">Yes</v-btn>
            <v-btn color="primary" flat @click.stop="confirmDialog=false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
  import firebase from 'firebase/app';
  import 'firebase/database';
  import moment from 'moment';
  import { mapGetters } from 'vuex';

export default{
  data() {
    return {
      isPacked: true,
      current: 0,
      loading: false,
      confirmDialog: false,
      orderPacked: false,
      streams: {
        full: { name: 'Full Nutrition' },
        athletic: { name: 'Low Carb' },
        slim: {name: 'Slim' },
        keto: {name: 'Keto'}
      }
    }
  },
  mounted(){
    this.current = this.itemIndex;
  },
  props:{
    items: Array,
    dayIndex: Number,
    itemIndex: Number,
    date: String,
    daysGroup: Array
  },
  methods:{
    getCodes: function(orders){
      let codes = '';
      for(let order of orders){
        let code = '';
        if(order.order_type === 'chefs_choice') {
          let meal = this.fedMenu.chefs_choices[order.tod].find((item) => item.id === order.meal_id);
          code = meal.code;
        }
        code += ` (x${order.quantity})`;
        codes += codes === '' ? code : `, <br />${code}`;
      }

      return codes;
    },
    getCustomQuantity: function(meals){
      let quantity = 0;
      if(meals && meals.length > 0){
        for(let meal of meals){
          if(meal.quantity){
            quantity += meal.quantity;
          }
        }
      }
      return quantity;
    },
    isMealOrdered: function(item, meal){
      if(!item.day[this.dateObject.day() - 1]){
        return false;
      }
      return item.day[this.dateObject.day() - 1][meal] === 1;
    },
    pack: function(confirmed = true){
      if(this.items[this.current].substitution && !confirmed){
        this.confirmDialog = true;
      } else {
        let db = firebase.database();
        db.ref(`orders/${this.week}/${this.order.uid}/packed/${this.day}`).set(this.isPacked);
        this.loadOrder(this.order.uid);
        this.$emit('updatePack', this.isPacked);
        this.$emit('packed', this.items[this.current], this.isPacked);
        this.confirmDialog = false;
      }
    },
    parseDate: function(date){
      return date.format("MMM Do YYYY");
    },
    loadOrder: function(uid){
      let db = firebase.database();
      let orderRef = db.ref(`orders/${this.week}/${uid}`);
      orderRef.on("value", snapshot => {
        let order = snapshot.val();
        this.orderPacked = order.packed && order.packed[this.day];
      });
    },
    selectBag: function(value) {
      let db = firebase.database();
      db.ref(`orders/${this.week}/${this.order.uid}/logistics/${this.day}/bags`).set(value);
      this.items[this.current].bags = value;
    }
  },
  watch:{
    'current': {
      immediate: true,
      handler: function(index){
        let uid = this.items[index].uid;
        this.loadOrder(uid);
      }
    }
  },
  computed: {
    ...mapGetters({
      'fedMenu': 'getMenu',
      'chefsChoice': 'getChefsChoice'
    }),
    dateObject() {
      return moment(this.date);
    },
    week(){
      let date = moment(this.date).day(5);
      let week = date.format('gggg_w'); //date.year() + "_" + date.week();
      return week;
    },
    day(){
      return moment(this.date).format('ddd').toLowerCase();
    },
    order(){
      return this.items[this.itemIndex];
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss">
  #order-details {
    th {
      font-size: 15px !important;
    }
    .badge__badge {
      height: 16px;
      width: 16px;
      font-size: 11px;
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/OrderDetails.vue